export default __webpack_public_path__ + "static/media/implementors.44289ac2.webp";